<template>
  <section
    class="title-with-two-cols-module-component"
    :class="`title-with-two-cols-module-component-${instance}`">
    <div
      class="main-content inner-container"
      :class="{ 'white-text': data.img }">
      <img
        v-if="data.img"
        alt=""
        :src="data.img.url" />
      <h2
        class="main-content-title"
        v-html="data.text" />
      <div class="main-content-text">
        <div
          class="main-content-text-l"
          v-html="data.left_col" />
        <div
          class="main-content-text-r"
          v-html="data.right_col" />
      </div>
    </div>
    <div class="inner-container btm">
      <div
        class="horizontal-line-btm"
        :class="`${lineH}`"
        :style="`background: ${lineColor()};`"></div>
      <div
        class="vertical-line-btm"
        :class="lineV"
        :style="`background: ${lineColor()};`"></div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "TitleWithTwoColsComponent",
  "CLASSNAME": "title-with-two-cols-module-component",
  "URL": "http://lifemine.local/templates/"
 }
#ENDMETA */
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import useUtils from '@/composables/useUtils'
import { onMounted, onBeforeUnmount } from 'vue'

gsap.registerPlugin(ScrollTrigger)

const props = defineProps(['data'])
const { genUUID } = useUtils()

const lineH = `top-line-h-${genUUID()}`
const lineV = `top-line-v-${genUUID()}`
const instance = genUUID()

const lineColor = () => {
  if (props.data.def_color) {
    return 'linear-gradient(260.12deg, #382C75 -0.82%, #6469B3 73.6%, #99B4FF 99.97%)'
  } else {
    return props.data.color
  }
}
const lineAnimation = () => {
  gsap.set(`.${lineH}`, { y: 39 })
  gsap.fromTo(
    `.${lineH}`,
    { scaleX: 0 },
    {
      scaleX: 1,
      scrollTrigger: {
        trigger: `.title-with-two-cols-module-component-${instance}`,
        id: lineH,
        start: 'bottom-=100 center+=20%',
        end: 'bottom+=139 center+=20%',
        scrub: true,
        // markers: true,
      },
    }
  )

  gsap.fromTo(
    `.${lineV}`,
    { scaleY: 0 },
    {
      scaleY: 1,
      scrollTrigger: {
        trigger: `.title-with-two-cols-module-component-${instance}`,
        id: lineV,
        start: 'bottom-=125 center+=20%',
        end: 'bottom-=100 center+=20%',
        scrub: true,
        // markers: true,
      },
    }
  )
}

onMounted(() => {
  lineAnimation()
})

onBeforeUnmount(() => {
  ScrollTrigger.getById(lineH)?.kill()
  ScrollTrigger.getById(lineV)?.kill()
})
</script>

<style lang="scss">
.title-with-two-cols-module-component {
  @apply relative pt-5;

  .inner-container.btm {
    @apply relative pb-10;

    .horizontal-line-btm {
      @apply h-px w-[calc(50%+1px)] origin-right;
    }

    .vertical-line-btm {
      @apply absolute h-[39px] w-[1px] left-1/2 top-0 z-10 origin-top;
    }
  }

  .main-content {
    @apply relative flex flex-col p-[60px] gap-9 max-w-[1300px] lg:px-[107px] lg:pt-[114px] lg:pb-[103px] lg:gap-16;

    img {
      @apply absolute left-0 top-0 -z-1 w-[calc(100%_-_60px)] h-full object-cover lg:w-full;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &-title {
      @apply heading-5 lg:heading-4 lg:font-nuances;
    }

    &-text {
      @apply flex flex-col gap-2 lg:flex-row lg:gap-11;

      &-l,
      &-r {
        @apply large flex flex-col gap-2 lg:flex-1 lg:gap-5;
      }
    }

    &.white-text {
      * {
        @apply text-white;
      }
    }
  }
}
</style>
